import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MatDatepickerToggle, MatDateRangeInput, MatDateRangePicker, MatEndDate, MatStartDate} from '@angular/material/datepicker';
import {FormsModule} from '@angular/forms';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateRange} from '../../domain/date-range';
import {CoreConfigurationService} from '../../core-configuration.service';
import {MatIcon} from '@angular/material/icon';
import moment, {Moment} from 'moment';

export const DATE_FORMATS = {
  parse: {
    dateInput: 'DD MM YY',
  },
  display: {
    dateInput: 'DD/MM/YY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-date-picker',
  imports: [
    MatDateRangeInput,
    FormsModule,
    MatDatepickerToggle,
    MatDateRangePicker,
    MatStartDate,
    MatEndDate,
    MatIcon
  ],
  templateUrl: './date-picker.component.html',
  styleUrl: './date-picker.component.css',
  standalone: true,
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]},
    {provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS},
    {provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: {useUtc: true, strict: false}}
  ]
})
export class DatePickerComponent {
  @Output() valueChanged = new EventEmitter();

  @Input() value: DateRange

  constructor(public coreConfiguration: CoreConfigurationService) {
  }

  fromDateChanged(value: Moment) {
    this.value.from = value?.toDate();

    this.valueChanged.emit(this.value);
  }

  toDateChanged(value: Moment) {
    this.value.to = value?.toDate();

    this.valueChanged.emit(this.value);
  }
}
